import { Check, Loader2 } from "lucide-react";

export function SectionStatus({ status, dirty, testId }) {
  if (status.state === "saving") {
    return <span data-testid={testId} className="inline-flex items-center gap-2 text-xs text-muted-foreground"><Loader2 className="h-3.5 w-3.5 animate-spin" />Saving</span>;
  }
  if (dirty) {
    return <span data-testid={testId} className="inline-flex items-center gap-2 text-xs text-gold"><span className="h-1.5 w-1.5 rounded-full bg-gold" />Unsaved changes</span>;
  }
  if (status.state === "saved") {
    return <span data-testid={testId} className="inline-flex items-center gap-2 text-xs text-emerald-800"><Check className="h-3.5 w-3.5" />{status.message}</span>;
  }
  return <span data-testid={testId} className="text-xs text-muted-foreground">All changes saved</span>;
}
